<div class="m-4 px-6 py-8 bg-white rounded-lg flex flex-col gap-6">
  <div class="flex flex-col gap-y-7 w-full">
    <div class="lg:px-8 px-0 pb-4 pt-8 bg-white border-[--brand-azul-primario] border-t">
      <div class="grid gap-5 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        @if (field) {
          <div class="w-full col-span-full">
            <app-reader-pdf [pdfReader]="field"></app-reader-pdf>
          </div>
        }
      </div>
    </div>
  </div>
</div>
